/**
 * Manual drawer-menu entry for the add-to-home-screen feature.
 * 「保存到桌面」的左侧抽屉菜单手动入口。
 *
 * The auto popup fires at most once per venue (promptRecord), so customers who
 * missed it or tapped "Maybe later" need a persistent way back in. The drawer
 * menu item is that way: it asks the prompt component to open via a $root
 * event, WITHOUT consuming the one-shot auto-prompt record.
 *
 * 自动弹窗每店只弹一次（promptRecord），错过或点了「以后再说」的顾客需要一个
 * 常驻入口。抽屉菜单项就是这个入口：通过 $root 事件请求弹窗组件打开，
 * 且**不**消耗一次性的自动弹窗记录。
 */

/**
 * $root event asking the mounted AddToHomeScreenPrompt to open right now.
 * $root 事件不依赖抽屉与弹窗在组件树里的相对位置（emitters.js 的 broadcast
 * 要按树递归），谁挂着谁响应。
 */
export const A2HS_MANUAL_OPEN_EVENT = 'a2hs-manual-open'

// Exactly the routes where AddToHomeScreenPrompt is mounted AND eligible:
// venue-home without a table number. Everything else would be a dead menu
// item — the drawer lives in App.vue and outlives the prompt component.
// - venue-home-table: dine-in, popup is pickup-only
// - *-sp routes: separate flow, excluded until product decides
// - cart / order-history / payment ...: prompt component not mounted at all
// - read-only aliases reuse these names, but NavBar hides the drawer there
// 只列弹窗组件真正挂载且 eligible 的路由：不带桌号的 venue-home。其余页面
// 出现入口就是个点了没反应的死按钮——抽屉在 App.vue 层，活得比弹窗组件长。
const MANUAL_ENTRY_ROUTE_NAMES = ['venue-home-pick', 'venue-home-no-table']

/**
 * Should the drawer show the "Add to home screen" item on this route?
 * 当前路由是否该显示抽屉里的「Add to home screen」入口？
 *
 * Route gate only — the caller must ALSO check the venue's backend flag and
 * canPromptAddToHomeScreenHere(). 只管路由这一关，后端开关与平台判定由调用方叠加。
 *
 * @param {string} routeName - $route.name
 * @returns {boolean}
 */
export function isManualEntryRoute(routeName) {
  return MANUAL_ENTRY_ROUTE_NAMES.indexOf(routeName) >= 0
}
